import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationsService } from "angular2-notifications";
import { Router, ActivatedRoute } from '@angular/router';
import { CadastrarVendasService } from './cadastrar-vendas.service';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-cadastrar-vendas',
  templateUrl: './cadastrar-vendas.component.html',
  styleUrls: ['./cadastrar-vendas.component.scss'],
})

export class CadastrarVendasComponent implements OnInit {

  public formCadastrarVendas: FormGroup = null;
  public listaStatus = null;
  public cnpjCpf = null;
  public isRegister = null;
  public iscnpjCpf = false;
  public isPesquisa = false;
  public isPorcento = false;
  public isValor = false;
  public isStatus = false;
  public tipoReuso = null;
  public valor = null;
  public cpfCnpj = null;
  public id = null;
  public listaForma = null;
  public customLogin = null;

  constructor(
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private location: Location,
    private service: CadastrarVendasService,
    private spinnerService: NgxSpinnerService,
  ) {

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formCadastrarVendas = this.formBuilder.group({
      cnpjCpf: [null],
      razaoSocial: [null],
      nomeFantasia: [null],
      valor: [null],
      porcento: [null],
      status: [null],
      formaDesconto: [null],

    });

    this.listaStatus = [

      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },
      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },
    ];

    this.listaForma = [

      {
        tipoReuso: 'VALOR',
        descricao: 'VALOR'
      },
      {
        tipoReuso: 'PERCENTUAL',
        descricao: 'PERCENTUAL'
      },
    ];

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.isRegister = this.encriptyService.decriptyBySecretKey(params.get('isRegister'));
      this.id = this.encriptyService.decriptyBySecretKey(params.get('id'));
      this.cpfCnpj = this.encriptyService.decriptyBySecretKey(params.get('cpfCnpj'));

      if (this.isRegister === 'S') {

        this.iscnpjCpf = true;
        this.isPesquisa = true;

      } else if (this.isRegister === 'N') {

        let q = new HttpParams();

        this.iscnpjCpf = false;
        this.isPesquisa = false;
        this.isStatus = true;

        q = q.append('id', this.id);
        q = q.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(this.cpfCnpj));

        this.service.retornaFornecedor(q, (response) => {

          const docRaw = this.normalizarCnpjCpfParaBackend(response.content[0].cpfCnpj);
          this.cnpjCpf = docRaw;
          this.formCadastrarVendas.controls['cnpjCpf'].setValue(docRaw);
          this.formCadastrarVendas.controls['razaoSocial'].setValue(response.content[0].razaoSocial);
          this.formCadastrarVendas.controls['nomeFantasia'].setValue(response.content[0].nomeFantasia);
          this.formCadastrarVendas.controls['status'].setValue(response.content[0].status);
          this.formCadastrarVendas.controls['formaDesconto'].setValue(response.content[0].tipoReuso);

          if (response.content[0].tipoReuso === "PERCENTUAL") {

            this.formCadastrarVendas.controls['porcento'].setValue(response.content[0].valor);
            this.isPorcento = true;
            this.isValor = false;

          } else if (response.content[0].tipoReuso === "VALOR") {

            this.formCadastrarVendas.controls['valor'].setValue(response.content[0].valor);
            this.isPorcento = false;
            this.isValor = true;

          }


        }, (error) => {
          this.notifications.error(error.message);
        });

      }
    });

  }

  getCpfCnpjMask(): string {
    const ctrl = this.formCadastrarVendas && this.formCadastrarVendas.get('cnpjCpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCpf != null && String(this.cnpjCpf).trim() !== ''
        ? this.cnpjCpf
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  selecioneDesconto(data) {

    if (data === 'PERCENTUAL') {

      this.isPorcento = true;
      this.isValor = false;
      this.tipoReuso = data;
      this.formCadastrarVendas.controls['valor'].setValue(null);

    } else if (data === 'VALOR') {

      this.isValor = true;
      this.isPorcento = false;
      this.tipoReuso = data;
      this.formCadastrarVendas.controls['porcento'].setValue(null);

    }

  }

  pesquisaReuso(data) {

    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    if (docNorm === '') {

      this.notifications.error("Campo CPF/CNPJ é obrigatório.");
      return;

    }

    let params = new HttpParams();
    params = params.append('cpfCnpj', docNorm);

    this.spinnerService.show();

    this.service.automaticReuse(params, (response => {

      this.spinnerService.hide();
      this.formCadastrarVendas.controls['razaoSocial'].setValue(response.content[0].razaoSocial);
      this.formCadastrarVendas.controls['nomeFantasia'].setValue(response.content[0].nomeFantasia);

    }), (error) => {
      this.notifications.error(error.message);
      this.spinnerService.hide();
    });

  }

  salvarReusoVenda(data) {
    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    const register = this.buildPayloadGeraReusoVenda(data, docNorm);

    this.spinnerService.show();

    if (this.isRegister === 'S') {
      this.executarGeraReusoVenda(register);
      return;
    }

    if (this.isRegister === 'N') {
      const params = this.buildHttpParamsAlteraReuso(data, docNorm);
      this.spinnerService.hide();
      this.executarAlteraDados(params);
    }
  }

  private buildPayloadGeraReusoVenda(data: any, docNorm: string): { cpfCnpj: string; tipoReuso: string; valor: any } | undefined {
    if (this.tipoReuso === 'PERCENTUAL') {
      return {
        cpfCnpj: docNorm,
        tipoReuso: this.tipoReuso,
        valor: data.porcento.replace('%', '').replace(' ', ''),
      };
    }
    if (this.tipoReuso === 'VALOR') {
      return {
        cpfCnpj: docNorm,
        tipoReuso: this.tipoReuso,
        valor: data.valor,
      };
    }
    return undefined;
  }

  private buildHttpParamsAlteraReuso(data: any, docNorm: string): HttpParams {
    let params = new HttpParams();

    if (docNorm !== '') {
      params = params.append('cpfCnpj', docNorm);
    }
    if (data.formaDesconto != null) {
      params = params.append('tipoReuso', data.formaDesconto);
    }
    if (data.status != null) {
      params = params.append('status', data.status);
    }

    params = this.appendValorAlteraReuso(params, data);

    if (this.id != null) {
      params = params.append('id', this.id);
    }

    return params;
  }

  private appendValorAlteraReuso(params: HttpParams, data: any): HttpParams {
    if (data.formaDesconto === 'PERCENTUAL' && data.porcento != null) {
      return params.append('valor', data.porcento.replace('%', '').replace(' ', ''));
    }
    if (data.formaDesconto === 'VALOR' && data.valor != null) {
      return params.append('valor', data.valor);
    }
    return params;
  }

  private executarGeraReusoVenda(register: { cpfCnpj: string; tipoReuso: string; valor: any } | undefined): void {
    this.service.geraReusoVenda(
      register,
      (response) => {
        this.spinnerService.hide();
        this.notifications.success(response.message);
        this.limparForms();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      },
    );
  }

  private executarAlteraDados(params: HttpParams): void {
    this.service.alteraDados(
      params,
      (response) => {
        this.spinnerService.hide();
        this.notifications.success(response.message);
        this.limparForms();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      },
    );
  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formCadastrarVendas.controls['valor'].setValue(null);
      this.notifications.error('Não é permitido números negativos!');

    }
    return true;

  }

  numberOnly(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 97) && (charCode <= 122)) {
      return false;
    }
    return true;

  }

  limparForms() {

    this.cnpjCpf = null;
    this.formCadastrarVendas = this.formBuilder.group({
      cnpjCpf: [null],
      razaoSocial: [null],
      nomeFantasia: [null],
      valor: [null],
      porcento: [null],
      status: [null],
      formaDesconto: [null],

    });

  }

  fecharForm() {

    this.location.back();

  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
